import React, { useState } from "react";
import { Card, CardContent, TextField, Button, Typography, Box, Avatar } from "@mui/material";
import FloatingPointsBackground from "./Components/FloatingPoints/FloatingPoints";

export default function LoginScreen({ onSuccess }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // const response = await fetch("http://localhost:5000/login", {
            const response = await fetch("https://dun.vydeo.xyz/iter3/login", {

                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password }),
                credentials: "include",
            });

            const data = await response.json();
            console.log("Login successful:", data);

            // console.log("logginig in")
            if (response.ok) {
                localStorage.setItem("token", data.token);
                onSuccess();
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Server error");
        }
    };

    return (
        <>
            <FloatingPointsBackground />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",

                }}
            >
                <Card sx={{
                    width: "400px",
                    padding: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.66)",
                    borderRadius: 5,
                    boxShadow: 4,
                    backdropFilter: "blur(10px)",
                }}
                >
                    <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {/* Logo */}
                        <Avatar
                            alt="Logo"
                            src="/shinsei.png"
                            sx={{ width: 100, height: 100, marginBottom: 2 }}
                        />
                        {/* App Name */}
                        <Typography variant="h5" sx={{ marginBottom: 2 }}>
                            DunderDebunk
                        </Typography>

                        {/* Password Input */}
                        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                            <TextField
                                type="password"
                                label="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                fullWidth
                                sx={{ marginBottom: 2 }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ marginBottom: 2 }}
                            >
                                Enter
                            </Button>
                        </form>

                        {/* Error message */}
                        {error && (
                            <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
                                {error}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </>
    );
}
